export default __webpack_public_path__ + "static/media/quoteIcon.c2ac57a5.svg";